import { render, staticRenderFns } from "./CustomTables.vue?vue&type=template&id=452ebf53"
import script from "./CustomTables.vue?vue&type=script&lang=js"
export * from "./CustomTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452ebf53')) {
      api.createRecord('452ebf53', component.options)
    } else {
      api.reload('452ebf53', component.options)
    }
    module.hot.accept("./CustomTables.vue?vue&type=template&id=452ebf53", function () {
      api.rerender('452ebf53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/CustomTables.vue"
export default component.exports